'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'stopwatch';
var width = 448;
var height = 512;
var aliases = [9201];
var unicode = 'f2f2';
var svgPathData = 'M144 24c0-13.3 10.7-24 24-24L280 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 25.3c49.6 5.5 94.1 27.7 127.8 61L399 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-26.8 26.8c21.4 33.5 33.9 73.4 33.9 116.2 0 119.3-96.7 216-216 216S8 407.3 8 288C8 176.8 92 85.3 200 73.3l0-25.3-32 0c-13.3 0-24-10.7-24-24zm80 96a168 168 0 1 0 0 336 168 168 0 1 0 0-336zm24 64l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStopwatch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;